// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__L2M0s","row":"ProcedureTreatmentSummary_row__2CTX5"};